import { useEffect, useRef, useState } from "react";
import "@/App.css";
import { 
  Shield, 
  TrendingDown, 
  Truck, 
  Search, 
  FileCheck, 
  Package, 
  CheckCircle,
  Phone,
  Mail,
  MapPin,
  Instagram,
  Facebook,
  ChevronRight,
  Star,
  Award,
  Lock,
  FileText,
  Users,
  Menu,
  X
} from "lucide-react";

// Logo URL
const LOGO_URL = "https://customer-assets.emergentagent.com/job_e1e61063-d49a-463f-9599-1c55bb5f4500/artifacts/ub17f6s6_WhatsApp%20Image%202026-02-04%20at%2020.16.50.jpeg";

// WhatsApp Configuration
const WHATSAPP_NUMBER = "+34600000000";
const WHATSAPP_MESSAGE = encodeURIComponent("Hola, quiero información sobre importación/compra de coche premium.");
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER.replace(/\+/g, '')}?text=${WHATSAPP_MESSAGE}`;

// Contact Info
const CONTACT = {
  email: "info@elitemotorgroup.es",
  address: "C/ Gran Vía, 123, Madrid",
  phone: WHATSAPP_NUMBER,
  instagram: "@elitemotorgroup",
  facebook: "@elitemotorgroup"
};

// Vehicle Catalog Data
const VEHICLES = [
  {
    id: 1,
    brand: "Mercedes-Benz",
    model: "AMG C 63 S",
    price: "Desde 54.900€",
    image: "https://images.unsplash.com/photo-1638731042279-66efd30eb17a?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    alt: "Mercedes-Benz AMG C 63 S negro importado desde Alemania",
    specs: "510 CV · 4.0L V8 Biturbo"
  },
  {
    id: 2,
    brand: "BMW",
    model: "M4 Competition",
    price: "Desde 62.500€",
    image: "https://images.unsplash.com/photo-1577952859599-3f691a2135c2?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    alt: "BMW M4 Competition blanco importación alemana premium",
    specs: "510 CV · 3.0L 6 Cilindros"
  },
  {
    id: 3,
    brand: "Audi",
    model: "RS e-tron GT",
    price: "Desde 89.900€",
    image: "https://images.unsplash.com/photo-1615222874898-37089fcf47ee?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    alt: "Audi RS e-tron GT eléctrico importado Alemania",
    specs: "646 CV · 100% Eléctrico"
  },
  {
    id: 4,
    brand: "Porsche",
    model: "911 Carrera S",
    price: "Desde 124.500€",
    image: "https://images.unsplash.com/photo-1726338195667-6750a2e8fa5f?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    alt: "Porsche 911 Carrera S negro comprar desde Alemania",
    specs: "450 CV · 3.0L Boxer"
  },
  {
    id: 5,
    brand: "Mercedes-Benz",
    model: "GLE 53 AMG Coupé",
    price: "Desde 78.900€",
    image: "https://images.unsplash.com/photo-1638731003363-e47f0c07f2c4?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    alt: "Mercedes-Benz GLE 53 AMG Coupé SUV premium alemán",
    specs: "435 CV · Híbrido Ligero"
  },
  {
    id: 6,
    brand: "Volkswagen",
    model: "Golf GTI Clubsport",
    price: "Desde 34.900€",
    image: "https://images.unsplash.com/photo-1753217976026-19763b647d6c?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    alt: "Volkswagen Golf GTI Clubsport negro importación",
    specs: "300 CV · 2.0L TSI"
  }
];

// Benefits Data
const BENEFITS = [
  {
    icon: <Truck className="w-8 h-8" />,
    title: "En menos de 25 días",
    description: "Desde que eliges tu coche hasta que lo tienes matriculado en tu casa. Proceso ágil, seguro y sin complicaciones."
  },
  {
    icon: <Shield className="w-8 h-8" />,
    title: "Garantía Oficial de Concesionario",
    description: "Todos nuestros vehículos mantienen su garantía oficial europea válida en cualquier concesionario de España."
  },
  {
    icon: <TrendingDown className="w-8 h-8" />,
    title: "Ahorro Real del 25-30%",
    description: "Precios cerrados sin sorpresas. Ahorra miles de euros respecto al mercado nacional con el mismo equipamiento."
  }
];

// Process Steps
const STEPS = [
  {
    number: "01",
    icon: <Search className="w-6 h-6" />,
    title: "Selección",
    description: "Elegimos juntos el vehículo ideal según tus preferencias entre nuestra red de proveedores alemanes verificados."
  },
  {
    number: "02",
    icon: <FileCheck className="w-6 h-6" />,
    title: "Verificación",
    description: "Inspección de 150 puntos, historial de mantenimiento en concesionario oficial y verificación de kilometraje."
  },
  {
    number: "03",
    icon: <Package className="w-6 h-6" />,
    title: "Importación",
    description: "Gestionamos todo: transporte asegurado, homologación, ITV y matriculación española. Precio cerrado."
  },
  {
    number: "04",
    icon: <CheckCircle className="w-6 h-6" />,
    title: "Entrega",
    description: "En menos de 25 días, tu coche matriculado en casa con garantía oficial de concesionario."
  }
];

// Brands
const BRANDS = [
  { name: "Mercedes-Benz", logo: "Mercedes-Benz" },
  { name: "BMW", logo: "BMW" },
  { name: "Audi", logo: "Audi" },
  { name: "Porsche", logo: "Porsche" },
  { name: "Volkswagen", logo: "Volkswagen" }
];

// Guarantees
const GUARANTEES = [
  {
    icon: <Shield className="w-6 h-6" />,
    title: "Garantía Oficial de Concesionario",
    description: "Todos los vehículos conservan su garantía oficial europea, válida en cualquier concesionario autorizado de España."
  },
  {
    icon: <Award className="w-6 h-6" />,
    title: "Inspección de 150 Puntos",
    description: "Informe técnico completo antes de la compra. Verificamos cada detalle para tu tranquilidad."
  },
  {
    icon: <FileText className="w-6 h-6" />,
    title: "Documentación 100% Legal",
    description: "Gestión completa de trámites: homologación, ITV, matriculación y transferencia. Todo en regla."
  },
  {
    icon: <Users className="w-6 h-6" />,
    title: "Proceso en Menos de 25 Días",
    description: "Desde que eliges tu coche hasta que lo tienes matriculado en tu casa. Rápido, seguro y sin complicaciones."
  }
];

// Intersection Observer Hook
const useIntersectionObserver = (options = {}) => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.unobserve(entry.target);
      }
    }, { threshold: 0.1, ...options });

    const currentRef = ref.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [options]);

  return [ref, isVisible];
};

// Header Component
const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { href: "#catalogo", label: "Catálogo" },
    { href: "#proceso", label: "Proceso" },
    { href: "#garantias", label: "Garantías" }
  ];

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled ? 'glass py-3' : 'bg-transparent py-5'
      }`}
      role="banner"
    >
      <div className="container-custom flex items-center justify-between">
        <a href="#" className="flex items-center" aria-label="Elite Motor Group - Inicio">
          <img 
            src={LOGO_URL} 
            alt="Elite Motor Group Logo - Importación coches premium Alemania" 
            className="h-10 md:h-14 w-auto object-contain"
            loading="eager"
          />
        </a>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-8" aria-label="Navegación principal">
          {navLinks.map((link) => (
            <a 
              key={link.href}
              href={link.href} 
              className="text-[#A3A3A3] hover:text-[#D4AF37] transition-colors duration-300 text-sm uppercase tracking-wider gold-border"
            >
              {link.label}
            </a>
          ))}
          <a 
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary text-xs"
            data-testid="header-whatsapp-btn"
          >
            <Phone className="w-4 h-4" />
            WhatsApp
          </a>
        </nav>

        {/* Mobile Menu Button */}
        <button 
          className="md:hidden text-[#F5F5F5] p-2"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label={isMobileMenuOpen ? "Cerrar menú" : "Abrir menú"}
          data-testid="mobile-menu-toggle"
        >
          {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>

        {/* Mobile Menu */}
        <div 
          className={`fixed inset-0 bg-black/95 backdrop-blur-lg md:hidden transition-all duration-500 ${
            isMobileMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
          }`}
          style={{ top: '70px' }}
        >
          <nav className="flex flex-col items-center justify-center gap-8 pt-20" aria-label="Navegación móvil">
            {navLinks.map((link) => (
              <a 
                key={link.href}
                href={link.href} 
                className="text-[#F5F5F5] hover:text-[#D4AF37] transition-colors duration-300 text-xl uppercase tracking-wider"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {link.label}
              </a>
            ))}
            <a 
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary mt-4"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <Phone className="w-5 h-5" />
              Contactar por WhatsApp
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
};

// Hero Section
const Hero = () => {
  const [ref, isVisible] = useIntersectionObserver();

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      aria-label="Sección principal"
    >
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1764552283704-ed67e7ad6059?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920')`,
        }}
        role="img"
        aria-label="Coche BMW premium en ambiente oscuro"
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black"></div>
      </div>

      {/* Content */}
      <div 
        ref={ref}
        className={`relative z-10 container-custom text-center px-6 py-32 ${isVisible ? 'reveal active' : 'reveal'}`}
      >
        <p className="text-[#D4AF37] uppercase tracking-[0.3em] text-sm mb-6 font-medium">
          Elite Motor Group
        </p>
        
        <h1 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold text-[#F5F5F5] mb-6 max-w-5xl mx-auto leading-tight">
          Importación y Compraventa de{' '}
          <span className="text-gold-gradient">Coches Premium</span>{' '}
          desde Alemania
        </h1>
        
        <p className="text-lg md:text-xl text-[#A3A3A3] max-w-3xl mx-auto mb-10 leading-relaxed">
          Especialistas en Mercedes-Benz, BMW, Audi, Porsche y Volkswagen. 
          Precio cerrado, garantía oficial de concesionario y en menos de 25 días en tu casa.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a 
            href="#catalogo" 
            className="btn-primary text-sm"
            data-testid="hero-catalog-btn"
          >
            Ver Catálogo
            <ChevronRight className="w-5 h-5" />
          </a>
          <a 
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-secondary text-sm"
            data-testid="hero-whatsapp-btn"
          >
            <Phone className="w-5 h-5" />
            Hablar por WhatsApp
          </a>
        </div>

        {/* Trust Indicators */}
        <div className="flex flex-wrap justify-center gap-8 mt-16 pt-8 border-t border-[#2A2A2A]">
          <div className="flex items-center gap-2 text-[#A3A3A3]">
            <Star className="w-5 h-5 text-[#D4AF37]" />
            <span className="text-sm">+500 vehículos importados</span>
          </div>
          <div className="flex items-center gap-2 text-[#A3A3A3]">
            <Shield className="w-5 h-5 text-[#D4AF37]" />
            <span className="text-sm">Garantía oficial de concesionario</span>
          </div>
          <div className="flex items-center gap-2 text-[#A3A3A3]">
            <Truck className="w-5 h-5 text-[#D4AF37]" />
            <span className="text-sm">Menos de 25 días</span>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 rounded-full border-2 border-[#D4AF37] flex items-start justify-center p-2">
          <div className="w-1.5 h-3 bg-[#D4AF37] rounded-full animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

// Benefits Section
const Benefits = () => {
  const [ref, isVisible] = useIntersectionObserver();

  return (
    <section className="section-padding bg-[#0B0B0B]" aria-labelledby="benefits-title">
      <div className="container-custom">
        <div 
          ref={ref}
          className={`text-center mb-16 ${isVisible ? 'reveal active' : 'reveal'}`}
        >
          <h2 id="benefits-title" className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#F5F5F5] mb-4">
            ¿Por qué <span className="text-gold-gradient">elegirnos</span>?
          </h2>
          <p className="text-[#A3A3A3] max-w-2xl mx-auto text-base md:text-lg">
            Más de 10 años de experiencia importando vehículos premium desde Alemania con total transparencia y seguridad.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {BENEFITS.map((benefit, index) => (
            <article 
              key={index}
              className={`p-8 bg-[#000000] border border-[#2A2A2A] hover:border-[#D4AF37]/50 transition-all duration-500 card-hover ${
                isVisible ? `reveal active delay-${(index + 1) * 100}` : 'reveal'
              }`}
            >
              <div className="w-16 h-16 flex items-center justify-center bg-[#D4AF37]/10 text-[#D4AF37] mb-6">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-bold text-[#F5F5F5] mb-3">{benefit.title}</h3>
              <p className="text-[#A3A3A3] leading-relaxed">{benefit.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

// Catalog Section
const Catalog = () => {
  const [ref, isVisible] = useIntersectionObserver();

  return (
    <section 
      id="catalogo" 
      className="section-padding bg-[#000000]"
      aria-labelledby="catalog-title"
    >
      <div className="container-custom">
        <div 
          ref={ref}
          className={`text-center mb-16 ${isVisible ? 'reveal active' : 'reveal'}`}
        >
          <h2 id="catalog-title" className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#F5F5F5] mb-4">
            Catálogo de <span className="text-gold-gradient">Vehículos</span>
          </h2>
          <p className="text-[#A3A3A3] max-w-2xl mx-auto text-base md:text-lg">
            Selección exclusiva de vehículos premium alemanes disponibles para importación inmediata.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {VEHICLES.map((vehicle, index) => (
            <article 
              key={vehicle.id}
              className={`group bg-[#0B0B0B] border border-[#2A2A2A] overflow-hidden card-hover ${
                isVisible ? `reveal-scale active delay-${(index % 3 + 1) * 100}` : 'reveal-scale'
              }`}
              data-testid={`vehicle-card-${vehicle.id}`}
            >
              <div className="relative overflow-hidden aspect-[4/3]">
                <img 
                  src={vehicle.image}
                  alt={vehicle.alt}
                  className="w-full h-full object-cover card-image"
                  loading="lazy"
                  width="400"
                  height="300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
                <div className="absolute bottom-4 left-4">
                  <span className="text-[#D4AF37] text-sm font-medium uppercase tracking-wider">
                    {vehicle.brand}
                  </span>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-[#F5F5F5] mb-2">
                  {vehicle.brand} {vehicle.model}
                </h3>
                <p className="text-[#A3A3A3] text-sm mb-4">{vehicle.specs}</p>
                <div className="flex items-center justify-between">
                  <span className="text-[#D4AF37] font-bold text-lg">{vehicle.price}</span>
                  <a 
                    href={WHATSAPP_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 text-[#F5F5F5] hover:text-[#D4AF37] transition-colors text-sm font-medium group"
                    data-testid={`vehicle-info-btn-${vehicle.id}`}
                  >
                    Más información
                    <ChevronRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className={`text-center mt-12 ${isVisible ? 'reveal active delay-500' : 'reveal'}`}>
          <a 
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-secondary"
            data-testid="catalog-contact-btn"
          >
            ¿Buscas otro modelo? Consúltanos
          </a>
        </div>
      </div>
    </section>
  );
};

// Brands Section
const BrandsSection = () => {
  const [ref, isVisible] = useIntersectionObserver();

  return (
    <section className="section-padding bg-[#0B0B0B]" aria-labelledby="brands-title">
      <div className="container-custom">
        <div 
          ref={ref}
          className={`text-center mb-16 ${isVisible ? 'reveal active' : 'reveal'}`}
        >
          <h2 id="brands-title" className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#F5F5F5] mb-6">
            Especialistas en <span className="text-gold-gradient">coches alemanes</span>
          </h2>
          <p className="text-[#A3A3A3] max-w-3xl mx-auto text-base md:text-lg leading-relaxed">
            Nos especializamos en las mejores marcas alemanas del mercado. 
            Mercedes-Benz, BMW, Audi, Porsche y Volkswagen son nuestras señas de identidad. 
            Alemania es el país de origen de estas marcas, lo que significa vehículos con mejor equipamiento, 
            precios más competitivos y acceso a versiones exclusivas no disponibles en España.
          </p>
        </div>

        {/* Brand Tags */}
        <div className={`flex flex-wrap justify-center gap-4 mb-16 ${isVisible ? 'reveal active delay-200' : 'reveal'}`}>
          {BRANDS.map((brand, index) => (
            <span 
              key={index}
              className="px-6 py-3 bg-[#000000] border border-[#2A2A2A] text-[#F5F5F5] text-sm uppercase tracking-wider hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors cursor-default"
            >
              {brand.name}
            </span>
          ))}
        </div>

        {/* Stats */}
        <div className={`grid md:grid-cols-3 gap-6 max-w-4xl mx-auto ${isVisible ? 'reveal active delay-300' : 'reveal'}`}>
          <div className="text-center p-8 bg-[#000000] border border-[#2A2A2A] hover:border-[#D4AF37]/50 transition-colors">
            <p className="text-[#D4AF37] font-bold text-4xl mb-2">25-30%</p>
            <p className="text-[#A3A3A3] text-sm">Ahorro medio respecto al mercado español</p>
          </div>
          <div className="text-center p-8 bg-[#000000] border border-[#2A2A2A] hover:border-[#D4AF37]/50 transition-colors">
            <p className="text-[#D4AF37] font-bold text-4xl mb-2">&lt;25</p>
            <p className="text-[#A3A3A3] text-sm">Días desde selección hasta matriculación</p>
          </div>
          <div className="text-center p-8 bg-[#000000] border border-[#2A2A2A] hover:border-[#D4AF37]/50 transition-colors">
            <p className="text-[#D4AF37] font-bold text-4xl mb-2">100%</p>
            <p className="text-[#A3A3A3] text-sm">Garantía oficial de concesionario</p>
          </div>
        </div>
      </div>
    </section>
  );
};

// Process Section
const Process = () => {
  const [ref, isVisible] = useIntersectionObserver();

  return (
    <section 
      id="proceso" 
      className="section-padding bg-[#000000]"
      aria-labelledby="process-title"
    >
      <div className="container-custom">
        <div 
          ref={ref}
          className={`text-center mb-16 ${isVisible ? 'reveal active' : 'reveal'}`}
        >
          <h2 id="process-title" className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#F5F5F5] mb-4">
            Cómo importamos <span className="text-gold-gradient">tu coche</span>
          </h2>
          <p className="text-[#A3A3A3] max-w-2xl mx-auto text-base md:text-lg">
            Un proceso transparente, seguro y sin complicaciones. Te acompañamos en cada paso.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {STEPS.map((step, index) => (
            <article 
              key={index}
              className={`relative text-center ${isVisible ? `reveal active delay-${(index + 1) * 100}` : 'reveal'}`}
            >
              <div className="relative inline-block mb-6">
                <div className="w-20 h-20 flex items-center justify-center bg-[#0B0B0B] border-2 border-[#D4AF37] rounded-full">
                  <span className="text-[#D4AF37] font-bold text-xl">{step.number}</span>
                </div>
                {index < STEPS.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 left-full w-full h-0.5 bg-gradient-to-r from-[#D4AF37] to-transparent -translate-y-1/2"></div>
                )}
              </div>
              <div className="flex items-center justify-center gap-2 mb-3">
                <span className="text-[#D4AF37]">{step.icon}</span>
                <h3 className="text-lg font-bold text-[#F5F5F5]">{step.title}</h3>
              </div>
              <p className="text-[#A3A3A3] text-sm leading-relaxed">{step.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

// Profitability Section
const Profitability = () => {
  const [ref, isVisible] = useIntersectionObserver();

  return (
    <section className="section-padding bg-[#0B0B0B]" aria-labelledby="profitability-title">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div 
            ref={ref}
            className={isVisible ? 'reveal-left active' : 'reveal-left'}
          >
            <h2 id="profitability-title" className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#F5F5F5] mb-6">
              Rentabilidad <span className="text-gold-gradient">real</span>
            </h2>
            <p className="text-[#A3A3A3] mb-8 text-base md:text-lg leading-relaxed">
              Importar un coche desde Alemania no es solo ahorrar dinero. Es acceder a vehículos mejor equipados, 
              con historiales de mantenimiento impecables en concesionarios oficiales, y una relación calidad-precio 
              imposible de encontrar en el mercado nacional.
            </p>
            
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#D4AF37]/10 text-[#D4AF37] flex-shrink-0">
                  <TrendingDown className="w-6 h-6" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-[#F5F5F5] mb-1">Mejores Precios</h3>
                  <p className="text-[#A3A3A3] text-sm">El mercado alemán de vehículos de ocasión es el más grande de Europa, lo que genera precios más competitivos.</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#D4AF37]/10 text-[#D4AF37] flex-shrink-0">
                  <Award className="w-6 h-6" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-[#F5F5F5] mb-1">Más Equipamiento</h3>
                  <p className="text-[#A3A3A3] text-sm">Los vehículos alemanes suelen incluir más extras de serie y paquetes premium que no llegan a España.</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#D4AF37]/10 text-[#D4AF37] flex-shrink-0">
                  <FileCheck className="w-6 h-6" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-[#F5F5F5] mb-1">Historial Verificado</h3>
                  <p className="text-[#A3A3A3] text-sm">Acceso completo al historial de mantenimiento en concesionario oficial y verificación de kilometraje real.</p>
                </div>
              </div>
            </div>
          </div>

          <div className={`relative ${isVisible ? 'reveal-right active delay-200' : 'reveal-right'}`}>
            <img 
              src="https://images.unsplash.com/photo-1769641240990-2b25a8c8d499?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"
              alt="Coche premium en garaje moderno - Importación desde Alemania"
              className="w-full h-auto object-cover"
              loading="lazy"
              width="800"
              height="600"
            />
            <div className="absolute -bottom-6 -left-6 bg-[#D4AF37] p-6 hidden md:block">
              <p className="text-[#000000] font-bold text-3xl">25-30%</p>
              <p className="text-[#000000] text-sm font-medium">Ahorro medio</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Guarantees Section
const Guarantees = () => {
  const [ref, isVisible] = useIntersectionObserver();

  return (
    <section 
      id="garantias" 
      className="section-padding bg-[#000000]"
      aria-labelledby="guarantees-title"
    >
      <div className="container-custom">
        <div 
          ref={ref}
          className={`text-center mb-16 ${isVisible ? 'reveal active' : 'reveal'}`}
        >
          <h2 id="guarantees-title" className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#F5F5F5] mb-4">
            Seguridad y <span className="text-gold-gradient">Garantías</span>
          </h2>
          <p className="text-[#A3A3A3] max-w-2xl mx-auto text-base md:text-lg">
            Tu tranquilidad es nuestra prioridad. Trabajamos con los más altos estándares de seguridad y legalidad.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {GUARANTEES.map((item, index) => (
            <article 
              key={index}
              className={`p-6 bg-[#0B0B0B] border border-[#2A2A2A] hover:border-[#D4AF37]/50 transition-all duration-300 ${
                isVisible ? `reveal active delay-${(index + 1) * 100}` : 'reveal'
              }`}
            >
              <div className="w-12 h-12 flex items-center justify-center bg-[#D4AF37]/10 text-[#D4AF37] mb-4">
                {item.icon}
              </div>
              <h3 className="text-lg font-bold text-[#F5F5F5] mb-2">{item.title}</h3>
              <p className="text-[#A3A3A3] text-sm leading-relaxed">{item.description}</p>
            </article>
          ))}
        </div>

        <div className={`mt-12 p-8 bg-[#0B0B0B] border border-[#D4AF37]/30 text-center ${isVisible ? 'reveal active delay-500' : 'reveal'}`}>
          <Shield className="w-12 h-12 text-[#D4AF37] mx-auto mb-4" />
          <h3 className="text-xl font-bold text-[#F5F5F5] mb-2">Proceso 100% Legal y Transparente</h3>
          <p className="text-[#A3A3A3] max-w-2xl mx-auto">
            Todos nuestros vehículos pasan por un riguroso proceso de verificación documental, 
            inspección técnica y homologación. Trabajamos con las autoridades competentes para 
            garantizar una importación sin problemas.
          </p>
        </div>
      </div>
    </section>
  );
};

// Final CTA Section
const FinalCTA = () => {
  const [ref, isVisible] = useIntersectionObserver();

  return (
    <section 
      className="section-padding bg-[#0B0B0B] relative overflow-hidden"
      aria-labelledby="cta-title"
    >
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-[#D4AF37]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#D4AF37]/5 rounded-full blur-3xl"></div>

      <div className="container-custom relative z-10">
        <div 
          ref={ref}
          className={`max-w-4xl mx-auto text-center ${isVisible ? 'reveal active' : 'reveal'}`}
        >
          <h2 id="cta-title" className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#F5F5F5] mb-6">
            Tu coche alemán con{' '}
            <span className="text-gold-gradient">garantía de concesionario</span>{' '}
            en menos de 25 días
          </h2>
          <p className="text-[#A3A3A3] text-lg mb-10 max-w-2xl mx-auto">
            Déjanos encontrar tu próximo vehículo. Te asesoramos sin compromiso, con precio cerrado 
            y garantía oficial válida en cualquier concesionario de España.
          </p>
          
          <a 
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary text-base px-10 py-4"
            data-testid="final-cta-btn"
          >
            <Phone className="w-5 h-5" />
            Solicitar Información
          </a>

          <div className="flex flex-wrap justify-center gap-6 mt-12 text-[#A3A3A3] text-sm">
            <span className="flex items-center gap-2">
              <CheckCircle className="w-4 h-4 text-[#D4AF37]" />
              Garantía oficial de concesionario
            </span>
            <span className="flex items-center gap-2">
              <CheckCircle className="w-4 h-4 text-[#D4AF37]" />
              Proceso en menos de 25 días
            </span>
            <span className="flex items-center gap-2">
              <CheckCircle className="w-4 h-4 text-[#D4AF37]" />
              Precio cerrado sin sorpresas
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

// Footer Component
const Footer = () => {
  return (
    <footer className="bg-[#000000] border-t border-[#2A2A2A] py-12" role="contentinfo">
      <div className="container-custom">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <img 
              src={LOGO_URL} 
              alt="Elite Motor Group Logo" 
              className="h-12 w-auto mb-4"
              loading="lazy"
            />
            <p className="text-[#A3A3A3] text-sm max-w-md mb-6">
              Especialistas en importación de vehículos premium desde Alemania. 
              Mercedes-Benz, BMW, Audi y Porsche con garantía oficial y proceso 100% legal.
            </p>
            <div className="flex gap-4">
              <a 
                href="https://instagram.com/elitemotorgroup" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-[#2A2A2A] text-[#A3A3A3] hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors"
                aria-label="Instagram de Elite Motor Group"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href="https://facebook.com/elitemotorgroup" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-[#2A2A2A] text-[#A3A3A3] hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors"
                aria-label="Facebook de Elite Motor Group"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-[#F5F5F5] font-bold mb-4 text-sm uppercase tracking-wider">Enlaces</h3>
            <nav aria-label="Enlaces del footer">
              <ul className="space-y-3">
                <li>
                  <a href="#catalogo" className="text-[#A3A3A3] hover:text-[#D4AF37] transition-colors text-sm">
                    Catálogo de Vehículos
                  </a>
                </li>
                <li>
                  <a href="#proceso" className="text-[#A3A3A3] hover:text-[#D4AF37] transition-colors text-sm">
                    Proceso de Importación
                  </a>
                </li>
                <li>
                  <a href="#garantias" className="text-[#A3A3A3] hover:text-[#D4AF37] transition-colors text-sm">
                    Garantías y Seguridad
                  </a>
                </li>
              </ul>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-[#F5F5F5] font-bold mb-4 text-sm uppercase tracking-wider">Contacto</h3>
            <address className="not-italic space-y-3">
              <p className="flex items-center gap-2 text-[#A3A3A3] text-sm">
                <Phone className="w-4 h-4 text-[#D4AF37]" />
                <a href={`tel:${CONTACT.phone}`} className="hover:text-[#D4AF37] transition-colors">
                  {CONTACT.phone}
                </a>
              </p>
              <p className="flex items-center gap-2 text-[#A3A3A3] text-sm">
                <Mail className="w-4 h-4 text-[#D4AF37]" />
                <a href={`mailto:${CONTACT.email}`} className="hover:text-[#D4AF37] transition-colors">
                  {CONTACT.email}
                </a>
              </p>
              <p className="flex items-start gap-2 text-[#A3A3A3] text-sm">
                <MapPin className="w-4 h-4 text-[#D4AF37] flex-shrink-0 mt-0.5" />
                <span>{CONTACT.address}</span>
              </p>
            </address>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-[#2A2A2A] flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#A3A3A3] text-xs">
            © {new Date().getFullYear()} Elite Motor Group. Todos los derechos reservados.
          </p>
          <p className="text-[#A3A3A3] text-xs">
            Importación de coches premium desde Alemania | Mercedes-Benz · BMW · Audi · Porsche
          </p>
        </div>
      </div>
    </footer>
  );
};

// Main App Component
function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {/* Loader */}
      <div className={`loader ${!loading ? 'hidden' : ''}`} aria-hidden={!loading}>
        <div className="loader-spinner"></div>
      </div>

      <div className="App">
        <Header />
        <main>
          <Hero />
          <Benefits />
          <Catalog />
          <BrandsSection />
          <Process />
          <Profitability />
          <Guarantees />
          <FinalCTA />
        </main>
        <Footer />
      </div>
    </>
  );
}

export default App;
